import { MenuItem, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {
  CustomSelect,
  CustomTextField,
  CustomCheckbox,
  CustomButton,
  HeaderFilterBox,
} from '../../../common';
import { generateYearMenuItems } from '../utils/couponsMailsUtils';
import { QUARTER_OPTIONS, MONTH_OPTIONS } from '../constants/couponsMailsConstants';

const CouponsMailsFilters = ({
  filter,
  handleFilter,
  includeAllSubscribers,
  onIncludeAllSubscribersChange,
  onSearch,
  plans,
  groups,
}) => {
  const filterStyles = {
    ml: { xs: 0, md: 2 },
    mt: 0,
    width: { xs: '100%', sm: '48%', md: '25%' },
    mb: { xs: 1, md: 0 },
  };

  return (
    <HeaderFilterBox variant="twoRows">
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center', mb: 2 }}>
        <CustomSelect
          label="Plan"
          name="plan"
          value={filter.plan}
          onChange={handleFilter}
          sx={filterStyles}
          size="medium"
        >
          {plans.map((plan) => (
            <MenuItem key={plan.uuid} value={plan.uuid}>
              {plan.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Grupo"
          name="group"
          value={filter.group}
          onChange={handleFilter}
          sx={filterStyles}
          size="medium"
          displayEmpty
        >
          <MenuItem value="">Todos</MenuItem>
          {groups.map((group) => (
            <MenuItem key={group.uuid} value={group.uuid}>
              {group.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomTextField
          label="N° Contrato"
          name="order"
          value={filter.order}
          onChange={handleFilter}
          sx={{ ...filterStyles, width: { xs: '100%', sm: '48%', md: '12%' } }}
          size="medium"
        />

        <CustomTextField
          label="Cuota pura"
          name="cuotaPura"
          value={filter.cuotaPura}
          onChange={handleFilter}
          sx={{ ...filterStyles, width: { xs: '100%', sm: '48%', md: '12%' } }}
          size="medium"
        />

        <CustomButton
          variant="contained"
          buttonIcon={SearchIcon}
          onClick={onSearch}
          sx={{ ml: { xs: 0, md: 2 }, minHeight: '55px' }}
          size="medium"
        >
          Buscar
        </CustomButton>
      </Box>

      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
        <CustomSelect
          label="Periodo"
          name="timePeriod"
          value={filter.timePeriod}
          onChange={handleFilter}
          sx={filterStyles}
          size="medium"
        >
          <MenuItem value="month">Mes</MenuItem>
          <MenuItem value="quarter">Trimestre</MenuItem>
        </CustomSelect>

        {filter.timePeriod === 'month' && (
          <CustomSelect
            label="Mes"
            name="month"
            value={filter.month}
            onChange={handleFilter}
            sx={filterStyles}
            size="medium"
          >
            {MONTH_OPTIONS.map((month) => (
              <MenuItem key={month.value} value={month.value}>
                {month.label}
              </MenuItem>
            ))}
          </CustomSelect>
        )}

        {/* Filtro condicional para trimestre */}
        {filter.timePeriod === 'quarter' && (
          <CustomSelect
            label="Trimestre"
            name="quarter"
            value={filter.quarter}
            onChange={handleFilter}
            sx={filterStyles}
            size="medium"
          >
            {QUARTER_OPTIONS.map((quarter) => (
              <MenuItem key={quarter.value} value={quarter.value}>
                {quarter.label}
              </MenuItem>
            ))}
          </CustomSelect>
        )}

        <CustomSelect
          label="Año"
          name="year"
          value={filter.year}
          onChange={handleFilter}
          sx={{ ...filterStyles, width: { xs: '100%', sm: '48%', md: '10%' } }}
          size="medium"
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: '300px',
                overflow: 'auto',
              },
            },
          }}
        >
          {generateYearMenuItems()}
        </CustomSelect>

        <CustomCheckbox
          checked={filter.notCancelled}
          onChange={handleFilter}
          name="notCancelled"
          label="No cancelados"
          sx={{ ml: { xs: 0, md: 1 } }}
        />

        <CustomCheckbox
          checked={includeAllSubscribers}
          onChange={onIncludeAllSubscribersChange}
          name="includeAllSubscribers"
          label="Enviar a todos"
          sx={{ ml: { xs: 0, md: 2 } }}
        />
      </Box>
    </HeaderFilterBox>
  );
};

export default CouponsMailsFilters;
